<script setup lang="ts">
import PrimeInputText from "primevue/inputtext";

withDefaults(defineProps<{ modelValue: string; placeholder?: string; ariaLabel?: string }>(), { placeholder: "" });
defineEmits<{ "update:modelValue": [value: string] }>();
</script>

<template>
  <PrimeInputText
    :model-value="modelValue"
    :placeholder="placeholder"
    :aria-label="ariaLabel"
    unstyled
    class="v-input"
    @update:model-value="$emit('update:modelValue', String($event))"
  />
</template>
